<template>
  <div class="container">
    <div class="tab-header">
      <span></span>
      <span>下载<br />Mbps</span>
      <span>上传<br />Mbps</span>
      <span>时延<br />ms</span>
      <template v-if="city == '全国'">
        <span>省</span>
        <span v-if="city == '全国'">城市/区</span>
      </template>
      <span v-if="city != '全国'">城市/区</span>
      <span>运营商</span>
    </div>
    <div class="tab-body">
      <div
        v-for="(item, index) in list"
        :key="index"
      >
        <span
          v-if="index + 1 < 4"
          style="background: #00D2FA"
        >{{ index + 1 }}</span>
        <span
          v-else
          style="background: #82889a"
        >{{ index + 1 }}</span>
        <span>{{ item.download }}</span>
        <span>{{ item.upload }}</span>
        <span>{{ item.ping }}</span>
        <template v-if="city == '全国'">
          <span :title="item.province">{{ item.province }}</span>
          <span
            v-if="item.city==='北京'||item.city==='上海'||item.city==='天津'||item.city==='重庆'"
            :title="item.city"
          >{{ item.district?item.district:'-' }}</span>
          <span v-else>{{ item.city }}</span>
        </template>
        <span
          v-if="city != '全国'"
          :title="(city === '北京' || city === '上海' || city === '天津' || city === '重庆')?item.district:item.city"
        >{{ (city === '北京' || city === '上海' || city === '天津' || city === '重庆')?(item.district?item.district:'-'):item.city }}</span>
        <span>{{ item.operator }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TabList',
  props: {
    list: {
      require: true,
      default: []
    }
  },
  computed: {
    ...mapState(['city'])
  },
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  .tab-header {
    width: 100%;
    height: 0.42rem;
    background: #001339;
    border-radius: 0.02rem;
    font-size: 0.12rem;
    font-weight: 400;
    color: #a1b0dc;
    position: relative;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      display: inline-block;
      //position: absolute;
      //top: 50%;
      //transform: translate(0, -50%);
    }
    span:nth-child(1) {
      width: 15px;
      height: 15px;
    }
    span:nth-child(2) {
      left: 27.67%;
      width: 15%;
    }
    span:nth-child(3) {
      left: 43.37%;
      width: 15%;
    }
    span:nth-child(4) {
      left: 54%;
      width: 10%;
    }
    span:nth-child(5) {
      left: 70.6%;
      width: 15%;
    }
    span:nth-child(6) {
      left: 87.71%;
      width: 15%;
    }
    span:last-child {
      width: 15%;
    }
  }
  .tab-body {
    height: calc(100% - 0.42rem);
    box-sizing: border-box;
    font-size: 0.12rem;
    font-weight: 400;
    color: #ffffff;
    padding: 0.15rem 0 .15rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      position: relative;
      width: 100%;
      height: 0.2rem;
      line-height: 0.15rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        //display: inline-block;
        //position: absolute;
      }
      span:nth-child(1) {
        width: 30PX;
        height: 30PX;
        font-size: 20PX;
        transform: scale(.5);
        border-radius: 100%;
        background-color: #00d2fa;
        text-align: center;
        line-height: 30PX;
        left: 1.93%;
      }
      span:nth-child(2) {
        left: 10.12%;
        width: 15%;
      }
      span:nth-child(3) {
        left: 27.67%;
        width: 15%;
      }
      span:nth-child(4) {
        left: 43.37%;
        width: 10%;
      }
      span:nth-child(5) {
        left: 54%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 15%;
        //width: 0.64rem;
      }
      span:nth-child(6) {
        left: 70.6%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        //width: 0.64rem;
        width: 15%;
      }
      span:last-child {
        left: 87.71%;
        width: 15%;
      }
    }
  }
}
@media screen and (min-width:900px) and (max-width:1500px){
  .container{
    .tab-header{
      span:nth-child(2) {
        width: 19%;
      }
      span:nth-child(3) {
        width: 19%;
      }
    }

    .tab-body {
      div {
        span:nth-child(2) {
          width: 19%;
        }
        span:nth-child(3) {
          width: 19%;
        }
      }
    }
  }
}
</style>
